import React from 'react'
import PropTypes from 'prop-types'
import {
  IllustrationErrorExplodingBalloon,
  CenteredContent,
  InformationBlockButton,
  ButtonPrimary,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import HelpContext from './HelpContext'
import { translator, Message } from 'mage-i18n'
import { connect } from 'react-redux'

ErrorPage.propTypes = {
  t: PropTypes.func.isRequired,
  errorId: PropTypes.string.isRequired,
  clearError: PropTypes.func.isRequired
}

function ErrorPage({ t, errorId, clearError }) {
  return (
    <HelpContext.Consumer>
      {({ reset }) => (
        <div style={{ margin: 30 }}>
          <CenteredContent
            illustration={<IllustrationErrorExplodingBalloon />}
            title={t('hqm.errorBoundary.title', {}, 'something went wrong')}
            summary={
              <>
                <div>
                  <Message
                    path="hqm.errorBoundary.message"
                    fallback="We are very sorry but there was an error. You can click the button below to reset and close this sidebar."
                  />
                  <SpacerVertical medium />
                  <ButtonPrimary
                    onClick={() => {
                      clearError()
                      reset()
                    }}
                  >
                    {t('hqm.errorBoundary.resetButton', {}, 'Reset')}
                  </ButtonPrimary>
                </div>
              </>
            }
          >
            <InformationBlockButton>
              <Message
                path="hqm.errorBoundary.errorId"
                params={{ errorId }}
                fallback="Error ID: {errorId}"
              />
            </InformationBlockButton>
          </CenteredContent>
        </div>
      )}
    </HelpContext.Consumer>
  )
}

const mapStateToProps = state => ({
  t: translator(state)
})

export default connect(mapStateToProps)(ErrorPage)
